module.exports = {"Phase 1":{"A1":["Basement","Upper Ground Floor","1","2","3","4","5","6","7","8","9","10","11","12","13","14","Roof"],"A2":["Basement","Upper Ground Floor","1","2","3","4","5","6","7","8","9","10","11","12","Roof"],"B1":["Basement","Upper Ground Floor","1","2","3","4","5","6","7","8","9","10","11","12","Roof"]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/poplar.json
// module id = 124
// module chunks = 0